/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MultiValue/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function MultiValue({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardCreate/MultiValue",
  onChange,
  isSubmitting
  
}) {
let txCardFieldDefinitionMultiValueValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'multi_value',
})
let txCardFieldDefinitionMultiValueChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'multi_value',
})
let txCardFieldDefinitionMultiValueIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Multi value"
 data="tx_card_field_definition.multi_value"
 value={txCardFieldDefinitionMultiValueValueData}
 onChange={txCardFieldDefinitionMultiValueChangeData}
 disabled={txCardFieldDefinitionMultiValueIsSubmittingData}
/>
{children}
</React.Fragment>)
}